import { createOrUpdateHomework, postQuestions } from "@/api/api";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        type: "Custom",
        name: "Custom",
      }),
    },
    createFields: {
      type: Object,
      default: () => ({}),
    },
    location: {
      type: String,
      default: "LIVE",
    },
  },
  data() {
    return {
      loading: false,
      rules: {
        required: (v) => !!v || "Field required",
      },
      crud: {
        title: "",
        subtitle: "",
        description: "",
        question_group: {
          questions: [],
        },
      },
    };
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = {
        ...this.crud,
        description: JSON.stringify(this.crud.description),
        location: this.location,
        ...this.createFields,
      };
      try {
        const response = await createOrUpdateHomework(crud);
        this.crud.uuid = response.data.uuid;

        if (response.data.question_group.uuid) {
          this.crud.question_group.uuid = response.data.question_group.uuid;
        } else this.crud.question_group.uuid = response.data.question_group;

        let newQuestions = { ...this.crud.question_group };
        newQuestions.questions = [...newQuestions.questions];
        newQuestions.questions = newQuestions.questions.map((element) => {
          if (typeof element.content === "string") {
            return { ...element };
          }
          return { ...element, content: JSON.stringify(element.content) };
        });

        const questions = await postQuestions(newQuestions);
        this.crud.question_group.questions.forEach((element, index) => {
          element.uuid = questions.questions[index].uuid;
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
  },
};
